import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { uploadBooking } from "../../services/FranchiseBookingServices";
import { ToastContainer, toast } from "react-toastify";

const FranchiseBookingForm = () => {
  const [contactInformation, setContactInformation] = useState({
    name: "",
    address: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    phoneNumber: "",
    emailAddress: "",
  });

  const [businessInformation, setBusinessInformation] = useState({
    currentOccupation: "",
    businessExperience: "",
    experienceInAgriculture: "",
    agricultureExperienceDescription: "",
  });

  const [franchisePreferences, setFranchisePreferences] = useState({
    preferredFranchiseType: "",
    preferredLocations: "",
    investmentCapacity: "",
    interestReason: "",
  });

  const [additionalInformation, setAdditionalInformation] = useState({
    howDidYouHearAboutUs: "",
    willingToUndergoTraining: "",
    additionalDetails: "",
  });

  const [declaration, setDeclaration] = useState({
    signature: "",
    date: "",
  });

  const sendData = async () => {
    // Perform validation before submitting
    if (validateForm()) {
      const isValidEmail = validateEmail(contactInformation.emailAddress);
      if (!isValidEmail) {
        toast.error("Invalid email format.");
        return;
      }

      const response = await uploadBooking(
        contactInformation,
        businessInformation,
        franchisePreferences,
        additionalInformation,
        declaration
      );
      if (response?.status === "success") {
        setContactInformation({
          name: "",
          address: "",
          city: "",
          state: "",
          postalCode: "",
          country: "",
          phoneNumber: "",
          emailAddress: "",
        });
        setBusinessInformation({
          currentOccupation: "",
          businessExperience: "",
          experienceInAgriculture: "",
          agricultureExperienceDescription: "",
        });
        setFranchisePreferences({
          preferredFranchiseType: "",
          preferredLocations: "",
          investmentCapacity: "",
          interestReason: "",
        });
        setAdditionalInformation({
          howDidYouHearAboutUs: "",
          willingToUndergoTraining: "",
          additionalDetails: "",
        });
        setDeclaration({
          signature: "",
          date: "",
        });
        toast.success("Data is successfully submitted");
      }
    }
  };

  // const validateForm = () => {
  //   // Array to store the names of empty fields
  //   const emptyFields = [];

  //   // Check each field and add its name to emptyFields if it's empty
  //   if (!contactInformation.name) emptyFields.push("Name");
  //   if (!contactInformation.address) emptyFields.push("Address");
  //   if (!contactInformation.city) emptyFields.push("City");
  //   if (!contactInformation.state) emptyFields.push("State");
  //   if (!contactInformation.postalCode) emptyFields.push("Postal Code");
  //   if (!contactInformation.country) emptyFields.push("Country");
  //   if (!contactInformation.phoneNumber) emptyFields.push("Phone Number");
  //   if (!contactInformation.emailAddress) emptyFields.push("Email Address");
  //   if (!businessInformation.currentOccupation)
  //     emptyFields.push("Current Occupation");
  //   if (!businessInformation.businessExperience)
  //     emptyFields.push("Business Experience");
  //   if (!businessInformation.experienceInAgriculture)
  //     emptyFields.push("Experience in Agriculture");
  //   if (!franchisePreferences.preferredFranchiseType)
  //     emptyFields.push("Preferred Franchise Type");
  //   if (!franchisePreferences.preferredLocations)
  //     emptyFields.push("Preferred Locations");
  //   if (!franchisePreferences.investmentCapacity)
  //     emptyFields.push("Investment Capacity");
  //   if (!franchisePreferences.interestReason)
  //     emptyFields.push("Interest Reason");
  //   if (!additionalInformation.howDidYouHearAboutUs)
  //     emptyFields.push("How did you hear about us?");
  //   if (!additionalInformation.willingToUndergoTraining)
  //     emptyFields.push("Willing to undergo training?");
  //   if (!declaration.signature) emptyFields.push("Signature");
  //   if (!declaration.date) emptyFields.push("Date");

  //   // If any fields are empty, show error message and return false
  //   if (emptyFields.length > 0) {
  //     toast.error(`Please fill in the : ${emptyFields.join(", ")}.`);
  //     return false;
  //   }

  //   // All fields are filled, return true
  //   return true;
  // };
  const validateForm = () => {
    // Array to store the names of empty fields
    const emptyFields = [];

    // Check each field and add its name to emptyFields if it's empty
    if (!contactInformation.name) emptyFields.push("Name");
    if (!contactInformation.address) emptyFields.push("Address");
    if (!contactInformation.city) emptyFields.push("City");
    if (!contactInformation.state) emptyFields.push("State");
    if (!contactInformation.postalCode) emptyFields.push("Postal Code");
    if (!contactInformation.country) emptyFields.push("Country");
    if (!contactInformation.phoneNumber) emptyFields.push("Phone Number");
    if (!contactInformation.emailAddress) emptyFields.push("Email Address");
    if (!businessInformation.currentOccupation)
      emptyFields.push("Current Occupation");
    if (!businessInformation.businessExperience)
      emptyFields.push("Business Experience");
    if (!businessInformation.experienceInAgriculture)
      emptyFields.push("Experience in Agriculture");
    if (!franchisePreferences.preferredFranchiseType)
      emptyFields.push("Preferred Franchise Type");
    if (!franchisePreferences.preferredLocations)
      emptyFields.push("Preferred Locations");
    if (!franchisePreferences.investmentCapacity)
      emptyFields.push("Investment Capacity");
    if (!franchisePreferences.interestReason)
      emptyFields.push("Interest Reason");
    if (!additionalInformation.howDidYouHearAboutUs)
      emptyFields.push("How did you hear about us?");
    if (!additionalInformation.willingToUndergoTraining)
      emptyFields.push("Willing to undergo training?");
    if (!declaration.signature) emptyFields.push("Signature");
    if (!declaration.date) emptyFields.push("Date");

    // If any fields are empty, show an error message for each and return false
    if (emptyFields.length > 0) {
      emptyFields.forEach((field, index) => {
        setTimeout(() => {
          toast.error(`Please fill in the ${field}.`);
        }, index * 200); // Adjust the delay as needed
      });
      return false;
    }

    // All fields are filled, return true
    return true;
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <div className="bg_clr_light_green py-5">
      <Container>
      <ToastContainer />
        <div className="bg-white p-lg-5 p-4 rounded-2">
          <div>
            <h2 className="mb-0 ff_heebo fw-bold fs_6xl_2">
              <span className="clr_dark_green">Franchise</span> Booking Form
            </h2>
            <p className="mb-0 text-dark-grey fs_md ff_heebo mt-2">
              Book Your Franchise by fill up the Details
            </p>
          </div>

          {/* Contact Information */}
          <div className="mt-4">
            <h4 className="mb-0 text-dark-grey fw-semibold fs_md ff_heebo mt-2">
              Contact Information
            </h4>
            <div>
              <div className="mt-4 d-flex align-items-center flex-column gap-4 flex-sm-row justify-content-between">
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="Name *"
                  value={contactInformation.name}
                  onChange={(e) =>
                    setContactInformation({
                      ...contactInformation,
                      name: e.target.value,
                    })
                  }
                />
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="Address *"
                  name="address"
                  value={contactInformation.address}
                  onChange={(e) =>
                    setContactInformation({
                      ...contactInformation,
                      address: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-4 d-flex align-items-center flex-column gap-4 flex-sm-row justify-content-between">
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="City *"
                  value={contactInformation.city}
                  onChange={(e) =>
                    setContactInformation({
                      ...contactInformation,
                      city: e.target.value,
                    })
                  }
                />
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="State *"
                  value={contactInformation.state}
                  onChange={(e) =>
                    setContactInformation({
                      ...contactInformation,
                      state: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-4 d-flex align-items-center flex-column gap-4 flex-sm-row justify-content-between">
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="Postal Code *"
                  value={contactInformation.postalCode}
                  onChange={(e) =>
                    setContactInformation({
                      ...contactInformation,
                      postalCode: e.target.value,
                    })
                  }
                />
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="Country *"
                  name="country"
                  value={contactInformation.country}
                  onChange={(e) =>
                    setContactInformation({
                      ...contactInformation,
                      country: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-4 d-flex align-items-center flex-column gap-4 flex-sm-row justify-content-between">
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="Phone Number *"
                  name="number"
                  value={contactInformation.phoneNumber}
                  onChange={(e) => {
                    const phoneNumber = e.target.value.replace(/\D/g, "");
                    if (phoneNumber.length <= 10) {
                      setContactInformation({
                        ...contactInformation,
                        phoneNumber,
                      });
                    }
                  }}
                />
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="Email Address *"
                  value={contactInformation.emailAddress}
                  onChange={(e) =>
                    setContactInformation({
                      ...contactInformation,
                      emailAddress: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>

          {/* Business Information */}
          <div className="mt-5">
            <h4 className="mb-0 text-dark-grey fw-semibold fs_md ff_heebo mt-2">
              Business Information
            </h4>
            <div>
              <div className="mt-4 d-flex align-items-center flex-column gap-3 flex-sm-row justify-content-between">
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="Current Occupation *"
                  onChange={(e) =>
                    setBusinessInformation({
                      ...businessInformation,
                      currentOccupation: e.target.value,
                    })
                  }
                />
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="number"
                  placeholder=" Business experience in years*"
                  onChange={(e) =>
                    setBusinessInformation({
                      ...businessInformation,
                      businessExperience: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-4 d-flex flex-column">
                <p className="mb-0 ff_heebo fs_sm">
                  Do you have experience in the agriculture sector?
                </p>
                <div className="d-flex align-items-center gap-5">
                  <div className="d-flex align-items-center gap-2 flex-row-reverse">
                    <label htmlFor="true">Yes</label>
                    <input
                      className="clr_dark_grey_4 mt-1"
                      type="radio"
                      id="true"
                      name="experienceInAgriculture"
                      value="true"
                      checked={
                        businessInformation.experienceInAgriculture === "true"
                      }
                      onChange={(e) =>
                        setBusinessInformation({
                          ...businessInformation,
                          experienceInAgriculture: e.target.value,
                          agricultureExperienceDescription: "", // Reset textarea value on change
                        })
                      }
                    />
                  </div>
                  <div className="d-flex align-items-center gap-2 flex-row-reverse">
                    <label htmlFor="false">No</label>
                    <input
                      className="clr_dark_grey_4 mt-1"
                      type="radio"
                      id="false"
                      name="experienceInAgriculture"
                      value="false"
                      checked={
                        businessInformation.experienceInAgriculture === "false"
                      }
                      onChange={(e) =>
                        setBusinessInformation({
                          ...businessInformation,
                          experienceInAgriculture: e.target.value,
                          agricultureExperienceDescription: "", // Reset textarea value on change
                        })
                      }
                    />
                  </div>
                </div>

                {businessInformation.experienceInAgriculture === "true" && (
                  <textarea
                    className="w-100 franchise-textarea rounded-2 mt-4 py-2 px-3 clr_dark_grey_4 w-100"
                    type="text"
                    placeholder="If yes, please describe *"
                    value={businessInformation.agricultureExperienceDescription}
                    onChange={(e) =>
                      setBusinessInformation({
                        ...businessInformation,
                        agricultureExperienceDescription: e.target.value,
                      })
                    }
                  />
                )}
              </div>
            </div>
          </div>

          {/* Franchise Preferences */}
          <div className="mt-5">
            <h4 className="mb-0 text-dark-grey fw-semibold fs_md ff_heebo mt-2">
              Franchise Preferences
            </h4>
            <div>
              <div className="mt-4 d-flex flex-column">
                <p className="mb-0 ff_heebo fs_sm">
                  {" "}
                  Preferred Franchise Type:
                </p>
                <div className="gap-md-5 gap-2 d-flex align-items-md-center flex-column flex-md-row mt-2">
                  <div>
                    <div className="d-flex align-items-center gap-2 cursor_pointer">
                      <input
                        className="clr_dark_grey_4 mt-1 cursor_pointer"
                        type="radio"
                        id="AgriInputs"
                        name="franchisePreferences"
                        value="Agri-Input Franchise Store"
                        onChange={(e) =>
                          setFranchisePreferences({
                            ...franchisePreferences,
                            preferredFranchiseType: e.target.value,
                          })
                        }
                      />
                      <label htmlFor="AgriInputs" className="cursor_pointer">
                        Agri-Input Franchise Store
                      </label>
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-2 cursor_pointer">
                      <input
                        className="clr_dark_grey_4 mt-1 cursor_pointer"
                        type="radio"
                        id="AgriOutputs"
                        name="franchisePreferences"
                        value="Agri-Output Franchise Store"
                        onChange={(e) =>
                          setFranchisePreferences({
                            ...franchisePreferences,
                            preferredFranchiseType: e.target.value,
                          })
                        }
                      />
                      <label htmlFor="AgriOutputs" className="cursor_pointer">
                        Agri-Output Franchise Store
                      </label>
                    </div>
                  </div>
                  <div>
                    <div className="d-flex align-items-start gap-2 cursor_pointer">
                      <input
                        className="clr_dark_grey_4 mt-1 cursor_pointer mt-2"
                        type="radio"
                        id="AgriInOut"
                        name="franchisePreferences"
                        value="Agri-Input & Agri-Output Franchise Store"
                        onChange={(e) =>
                          setFranchisePreferences({
                            ...franchisePreferences,
                            preferredFranchiseType: e.target.value,
                          })
                        }
                      />
                      <label htmlFor="AgriInOut" className="cursor_pointer">
                        Agri-Input & Agri-Output Franchise Store
                      </label>
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-2 cursor_pointer">
                      <input
                        className="clr_dark_grey_4 mt-1 cursor_pointer"
                        type="radio"
                        id="DroneEntrepreneur"
                        name="franchisePreferences"
                        value="Drone Entrepreneur Franchise Store"
                        onChange={(e) =>
                          setFranchisePreferences({
                            ...franchisePreferences,
                            preferredFranchiseType: e.target.value,
                          })
                        }
                      />
                      <label
                        htmlFor="DroneEntrepreneur"
                        className="cursor_pointer"
                      >
                        Drone Entrepreneur Franchise Store
                      </label>
                    </div>
                  </div>
                </div>

                <div className="mt-4 d-flex align-items-center flex-column gap-3 gap-md-0 flex-md-row justify-content-between">
                  <input
                    className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                    type="text"
                    placeholder="Preferred Location(s) for Franchise *"
                    name="preferredLocations"
                    value={franchisePreferences.preferredLocations}
                    onChange={(e) =>
                      setFranchisePreferences({
                        ...franchisePreferences,
                        preferredLocations: e.target.value,
                      })
                    }
                  />
                  <input
                    className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                    type="number"
                    placeholder="Investment Capacity (INR) *"
                    name="investmentCapacity"
                    value={franchisePreferences.investmentCapacity}
                    onChange={(e) =>
                      setFranchisePreferences({
                        ...franchisePreferences,
                        investmentCapacity: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mt-4">
                  <textarea
                    className="franchise-textarea px-3 clr_dark_grey_4 w-100 rounded-2 py-2"
                    placeholder="Why are you interested in becoming a franchise owner?"
                    name="interestReason"
                    value={franchisePreferences.interestReason}
                    onChange={(e) =>
                      setFranchisePreferences({
                        ...franchisePreferences,
                        interestReason: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div className="mt-5">
            <h4 className="mb-0 text-dark-grey fw-semibold fs_md ff_heebo mt-2">
              Additional Information
            </h4>
            <div>
              <div className="mt-4 d-flex align-items-center justify-content-between">
                <input
                  className="franchise-inputs px-3 clr_dark_grey_4 w-100"
                  type="text"
                  placeholder="How did you hear about us? *"
                  name="howDidYouHearAboutUs"
                  value={additionalInformation.howDidYouHearAboutUs}
                  onChange={(e) =>
                    setAdditionalInformation({
                      ...additionalInformation,
                      howDidYouHearAboutUs: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-4 d-flex gap-3 align-items-md-center flex-column flex-md-row">
                <p className="mb-0 ff_heebo fs_sm">
                  Are you willing to undergo training provided by Farmer City?
                </p>
                <div className="d-flex align-items-center gap-4">
                  <div className="d-flex gap-2 align-items-center">
                    <input
                      className="mt-1 mt-md-1"
                      type="radio"
                      id="agricultureExperienceYes"
                      name="agricultureExperience"
                      value="true"
                      checked={
                        additionalInformation.willingToUndergoTraining ===
                        "true"
                      }
                      onChange={(e) =>
                        setAdditionalInformation({
                          ...additionalInformation,
                          willingToUndergoTraining: e.target.value,
                        })
                      }
                    />
                    <label htmlFor="agricultureExperienceYes">Yes</label>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <input
                      className="mt-1 mt-md-0"
                      type="radio"
                      id="agricultureExperienceNo"
                      name="agricultureExperience"
                      value="false"
                      checked={
                        additionalInformation.agricultureExperience === "false"
                      }
                      onChange={(e) =>
                        setAdditionalInformation({
                          ...additionalInformation,
                          agricultureExperience: e.target.value,
                        })
                      }
                    />
                    <label htmlFor="agricultureExperienceNo">No</label>
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <textarea
                  className="franchise-textarea px-3 clr_dark_grey_4 w-100 rounded-2 py-2"
                  placeholder="Any other information you would like to share?"
                  value={additionalInformation.additionalDetails}
                  onChange={(e) =>
                    setAdditionalInformation({
                      ...additionalInformation,
                      additionalDetails: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>

          {/* Declaration */}
          <div>
            <p className="mb-0 ff_heebo fs_sm mt-5 text-dark-grey">
              I hereby declare that the information provided above is true and
              correct to the best of my knowledge. I understand that this is an
              expression of interest and does not obligate either party to enter
              into a franchise agreement
            </p>
            <div className="d-flex flex-column">
              <input
                style={{ maxWidth: "250px" }}
                className="franchise-inputs px-1 clr_dark_grey_4 w-100"
                type="text"
                placeholder="Signature *"
                onChange={(e) =>
                  setDeclaration({ ...declaration, signature: e.target.value })
                }
              />
              <input
                style={{ maxWidth: "250px" }}
                className="franchise-inputs px-1 clr_dark_grey_4 w-100"
                type="date"
                placeholder="date *"
                onChange={(e) => {
                  const date = new Date(e.target.value);
                  const formattedDate = `${date.getFullYear()}-${(
                    "0" +
                    (date.getMonth() + 1)
                  ).slice(-2)}-${("0" + date.getDate()).slice(-2)}`;
                  setDeclaration({ ...declaration, date: formattedDate });
                }}
              />
            </div>
          </div>
          <button
            onClick={sendData}
            style={{ width: "160px", height: "40px" }}
            className="common-darkgreen-button mt-4 text-uppercase mx-auto px-4 ff_heebo fw-medium text-white text-uppercase rounded-3 fs_xxsm"
          >
            Submit
          </button>
        </div>
      </Container>
    </div>
  );
};

export default FranchiseBookingForm;
